import React from "react";

import { MainNavigation } from "./main-navigation";

interface MainLayoutProps {
  children: React.ReactNode;
}

export function MainLayout({ children }: MainLayoutProps) {
  return (
    <div className="min-h-screen bg-background">
      <MainNavigation />

      <main className="flex-1">{children}</main>
    </div>
  );
}
